export default class DmCoreError extends Error {
  constructor(
    message: string,
    public status: number,
    public body: unknown = undefined
  ) {
    super(message)
    this.name = 'DmCoreError'
    Object.setPrototypeOf(this, DmCoreError.prototype)
  }
}
